// extracted by mini-css-extract-plugin
module.exports = {"list":"_1NSOwR1g","circle":"_4Rtm2Pbr","middleCircle":"_2_d3cI3C","ls":"_2E7Cxxl8","text":"_263Cj14h","disableArrow":"_3ILjTVsH","disable":"G8tYV1Oc"};